import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be62db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word_cloud_wrap" }
const _hoisted_2 = { class: "board_table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "20%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "순번"),
    /*#__PURE__*/_createElementVNode("th", null, "키워드"),
    /*#__PURE__*/_createElementVNode("th", null, "결과 수")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { colspan: 10 }
const _hoisted_8 = { class: "board_graph_list wordcloud_graph" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_NoResult = _resolveComponent("NoResult")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!$setup.props.loading && $setup.props.chartData)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.chartData.slice(0, 20), (item, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(item.keyword), 1),
                _createElementVNode("td", null, _toDisplayString(item.cnt.toLocaleString()), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_7, [
                _createVNode(_component_Spinner)
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!$setup.props.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($setup.chartData)
              ? (_openBlock(), _createBlock(_component_Chart, {
                  key: 0,
                  style: {"min-height":"400px"},
                  defaultLayout: $setup.chartLayout,
                  data: $setup.chartData
                }, null, 8, ["defaultLayout", "data"]))
              : (_openBlock(), _createBlock(_component_NoResult, { key: 1 }))
          ], 64))
        : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
    ])
  ]))
}